import React, { useEffect, useState } from "react"

import './styles.css';
import { useFormik } from 'formik';
import { usePrimeiroAgendamentoContext } from "../contexts/PrimeiroAgendamentoContext";
import DefaultTabs from "../../../../components/Accessibility/DefaultTabs";
import PageTitle from "../../../../components/Accessibility/PageTitle";
import { TipoAtendimentoForm } from "./TipoAtendimentoForm";
import VoltarButton from "../../../../components/Accessibility/VoltarButton";
import { agendarAdesao, getTipoAtendimentoAdesao } from "../../../../services/SaudeBemEstar/PrimeiroAgendamentoService";
import { ITipoAtendimento } from "../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/TipoAtendimento";
import LoadingApp from "../../../../components/LoadingApp";
import { AgendarAtendimentoFormik } from "../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/AgendarAtendimentoFormik";
import { DataHorarioForm } from "./DataHorarioForm";
import { ConfirmarDados, UserData } from "./ConfirmarDados";
import ModalFeedBack from "../../../../components/ModalFeedBack";
import { useNavigate, useParams } from "react-router-dom";

export const AgendarAtendimento: React.FC = () => {
    const { idComunic } = useParams();
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false)
    const { tabs, setSteps, setTabs, termoResponsabilidade } = usePrimeiroAgendamentoContext()
    const [tipoAtendimento, setTipoAtendimento] = useState<ITipoAtendimento>({} as ITipoAtendimento)
    const [modalFeedback, setModalFeedback] = useState<null | {
        icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
        closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
    }>(null);


    const closeErrorModalFeedback = () => {
        setModalFeedback(null);
    }

    const closeModalFeedback = () => {
        navigate('/saudeBemEstar/gestaoDeCronicos')
    }

    const formik = useFormik<AgendarAtendimentoFormik>({
        initialValues: {
            userData: {} as UserData,
            idComunic: '',
            idTermoResponsabilidade: '',
            tipoAtend: '',
            area: '',
            selectedDate: null,
            selectedHour: null
        },
        onSubmit: (values) => {
            setLoading(true)
            const data = {
                idInstal: values.selectedHour?.idInstal || '',
                idPrestador: values.selectedHour?.idPrestador || '',
                espec: values.selectedHour?.especialidade || '',
                email: values.userData?.email || '',
                tel: values.userData?.tel || '',
                cel: values.userData?.cel || '',
                idTermoResponsabilidade: termoResponsabilidade?.idTermoResponsabilidade || '',
                tipoAtend: values.tipoAtend,
                idComunic: idComunic || '',
                data: `${values.selectedHour?.data} ${values.selectedHour?.hora}`
            }
            agendarAdesao(data).then(
                () => {
                    setModalFeedback({
                        icon: 'success',
                        closeAction: closeModalFeedback,
                        title: 'Gestão de crônicos',
                        subTitle: 'Agora você tem acesso à área exclusiva do Gestão de crônicos no Canal do Cliente para marcar atendimentos, falar com nossa equipe, ver conteúdos e acompanhar seu progresso. Conheça!',
                        textButton: 'IR PARA GESTÃO DE CRÔNICOS',
                        showButtonModal: true,
                        buttonAction: closeModalFeedback
                    });
                },
                (response) => {
                    setModalFeedback({
                        icon: 'error',
                        closeAction: closeErrorModalFeedback,
                        title: 'Atenção!',
                        subTitle: response?.mensagem ?? "Erro ao agendar atendimento",
                        textButton: "Fechar",
                        showButtonModal: true,
                        buttonAction: closeErrorModalFeedback
                    });
                }

            ).finally(() => setLoading(false))
        },
    });

    const handleGetTipoAtendimentoAdesao = () => {
        setLoading(true)
        getTipoAtendimentoAdesao().then((response) => {
            setTipoAtendimento(response)
        }).finally(() => setLoading(false))
    }

    useEffect(() => {
        handleGetTipoAtendimentoAdesao()
    }, [])


    const handleBack = () => {
        if (tabs !== 0) {
            setTabs((prev) => prev - 1)
            return
        }
        setSteps((prev) => prev - 1)
    }

    const renderSwitch = (step: number) => {
        switch (step) {
            case 0: return <TipoAtendimentoForm tipoAtendimento={tipoAtendimento} formik={formik} />
            case 1: return <DataHorarioForm formik={formik} />
            case 2: return <ConfirmarDados formik={formik} />
        }
    }

    return (
        <div className='page-container'>
            <LoadingApp showLoading={loading} text={'Carregando...'} />
            <div className="page-container-title">
                <PageTitle text="Agendar atendimento" />
            </div>
            <div className="width-100 page-container-tabs">
                <DefaultTabs 
                    step={tabs} 
                    stepLabels={["Tipo de atendimento", "Horário", "Confirmação"]} 
                    onTabClick={setTabs}
                />
            </div>

            {renderSwitch(tabs)}

            <VoltarButton
                onClick={handleBack} />
            <ModalFeedBack
                showModal={!!modalFeedback}
                handleShowModal={modalFeedback?.closeAction}
                title={modalFeedback?.title as string}
                subTitle={modalFeedback?.subTitle as string}
                icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
                showButtonModal={modalFeedback?.showButtonModal}
                textButton={modalFeedback?.textButton as string}
                handleButtonModal={modalFeedback?.buttonAction}
                classNameModal="modal-custom"
            />
        </div>
    )
}